export const Roles = {
    TEACHER: 'TEACHER',
    TEACHER_REMOTE: 'TEACHER_REMOTE',
    PARENT: 'PARENT',
    STUDENT: 'STUDENT',
    EDITOR: 'EDITOR',
    GUEST: 'GUEST',
    TUTOR: 'TUTOR',
    TUTOR_USER: 'TUTOR_USER',
    ONECLASS_TEACHER: 'ONECLASS_TEACHER',
    ONECLASS_STUDENT: 'ONECLASS_STUDENT',
    INTERACTIVITY_STUDENT: 'INTERACTIVITY_STUDENT',
};

export const RoleDisplayMap = {
    [Roles.TEACHER]: '教師',
    [Roles.TEACHER_REMOTE]: '教師',
    [Roles.STUDENT]: '學生',
    [Roles.PARENT]: '家長',
    [Roles.EDITOR]: '編輯',
    [Roles.GUEST]: '訪客',
    [Roles.TUTOR]: 'TUTOR',
    [Roles.TUTOR_USER]: 'TUTOR_USER',
    [Roles.ONECLASS_TEACHER]: 'ONECLASS_TEACHER',
    [Roles.ONECLASS_STUDENT]: 'ONECLASS_STUDENT',
    [Roles.INTERACTIVITY_STUDENT]: '學生',
};
